import { err, validators } from '../utils';
import {
  isPolicyBundle,
  type PolicyBundleWithEligibility,
} from '../utils/types/Entity';
import axios, { AxiosResponse } from 'axios';

const URL = '/api/policy-bundle';

const getPolicyBundles = async (
  token: string,
): Promise<PolicyBundleWithEligibility[]> => {
  try {
    const res: AxiosResponse<{ bundles: PolicyBundleWithEligibility[] }> =
      await axios.get(URL, {
        headers: { Authorization: `Bearer ${token}` },
      });
    if (res.status < 200 || res.status >= 300) {
      throw new Error(`${res.status} error`);
    }
    const { bundles } = res.data;

    validators.arrayValidator(bundles, 'bundles', {
      typeguard: isPolicyBundle,
    });

    return bundles;
  } catch (e) {
    throw err.handleError(e, 'error getting bundles');
  }
};

const getPolicyBundleByID = async (
  token: string,
  id: string,
): Promise<PolicyBundleWithEligibility> => {
  try {
    const res: AxiosResponse<{ bundle: PolicyBundleWithEligibility }> =
      await axios.get(`${URL}/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
    if (res.status < 200 || res.status >= 300) {
      throw new Error(`${res.status} error`);
    }

    const { bundle } = res.data;
    isPolicyBundle(bundle);
    return bundle;
  } catch (e) {
    throw err.handleError(e, 'error getting bundle');
  }
};

export default { getPolicyBundles, getPolicyBundleByID };
